import { Component, HostListener } from '@angular/core';
 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'project';
  @HostListener('document:keydown', ['$event'])

  handleKeyboardEvent(e: KeyboardEvent) {
    if (e.key === 'F12') {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.key === "I") {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.key === "C") {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.key === "J") {
      return false;
    }
    if (e.ctrlKey && e.key == "U") {
      return false;
    }
    return true;
  }

  constructor() {
    // let devtools = { open: false, orientation: null };
    
    // let threshold = 160;
    
    // let checkDevTools = () => {
    //     let widthThreshold = window.outerWidth - window.innerWidth > threshold;
    //     let heightThreshold = window.outerHeight - window.innerHeight > threshold;
        
    //     if (widthThreshold || heightThreshold) {
    //         devtools.open = true;
    //         console.warn("DevTools detected! Reloading...");
    //         location.reload();
    //     }
    // };

    // setInterval(checkDevTools, 1000);
  
    // document.addEventListener("contextmenu", (event) => event.preventDefault());

    // document.addEventListener("keydown", (event) => {
    //     if (event.ctrlKey && (event.key === "u" || event.key === "U")) {
    //         event.preventDefault();
    //     }
    //     if (event.ctrlKey && event.shiftKey && (event.key === "i" || event.key === "I")) {
    //         event.preventDefault();
    //     }
    //     if (event.ctrlKey && event.shiftKey && (event.key === "j" || event.key === "J")) {
    //         event.preventDefault();
    //     }
    //     if (event.ctrlKey && event.shiftKey && (event.key === "c" || event.key === "C")) {
    //         event.preventDefault();
    //     }
    //     if (event.key === 'F12') {
    //         event.preventDefault();
    //     }
    //     if (event.ctrlKey && event.key === "s") {
    //         event.preventDefault();
    //     }
    //     if (event.ctrlKey && event.key === "c") {
    //         event.preventDefault();
    //     }
    // });
  }
 
}
